import { MapPin, Wrench, Sparkles, LineChart } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      icon: MapPin,
      title: "Sélection des fragrances",
      description:
        "Choisissez les parfums que vous souhaitez distribuer et définissez vos objectifs."
    },
    {
      number: "02",
      icon: Wrench,
      title: "Déploiement dans notre réseau",
      description:
        "Nous installons vos fragrances dans nos diffuseurs, au sein de notre réseau de lieux premium."
    },
    {
      number: "03",
      icon: Sparkles,
      title: "Interaction client",
      description:
        "Les utilisateurs découvrent votre parfum au moment idéal, créant une connexion émotionnelle forte."
    },
    {
      number: "04",
      icon: LineChart,
      title: "Analyse des performances",
      description:
        "Recevez des rapports détaillés sur l'engagement et optimisez votre stratégie."
    }
  ];

  return (
    <section
      id="fonctionnement"
      data-testid="how-it-works-section"
      className="bg-white py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left Column - Header */}
          <div>
            <p
              data-testid="how-label"
              className="font-body text-sm tracking-[0.2em] uppercase text-[#B89F7C] mb-6"
            >
              Comment ça marche
            </p>
            <h2
              data-testid="how-headline"
              className="font-heading text-4xl sm:text-5xl font-light tracking-tight leading-tight text-[#0A0A0A] mb-8"
            >
              Un processus simple,
              <br />
              <span className="italic">des résultats mesurables</span>
            </h2>
            <p className="font-body text-lg font-light leading-relaxed text-[#525252]">
              De la sélection de vos fragrances à l'analyse des performances,
              nous gérons tout pour vous.
            </p>
          </div>

          {/* Right Column - Steps Timeline */}
          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-4 top-8 bottom-8 w-[1px] bg-[#E5E5E5] hidden md:block"></div>

            <div className="space-y-12">
              {steps.map((step) => (
                <div
                  key={step.number}
                  data-testid={`step-${step.number}`}
                  className="flex gap-8 relative"
                >
                  {/* Step Number Circle */}
                  <div className="hidden md:flex items-center justify-center w-8 h-8 bg-white border border-[#E5E5E5] text-[#0A0A0A] font-body text-xs font-medium shrink-0 relative z-10">
                    {step.number}
                  </div>

                  {/* Step Content */}
                  <div className="flex-1">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="md:hidden font-body text-sm text-[#B89F7C]">
                        {step.number}
                      </span>
                      <step.icon
                        strokeWidth={1}
                        size={24}
                        className="text-[#B89F7C]"
                      />
                    </div>
                    <h3 className="font-heading text-xl font-normal text-[#0A0A0A] mb-2">
                      {step.title}
                    </h3>
                    <p className="font-body text-sm font-light leading-relaxed text-[#525252]">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
